import { Directive, HostBinding } from '@angular/core';

/**
 * Clarity projects record in strict masking (all text hidden). Clarity shows
 * a node and every descendant when it has `data-clarity-unmask="true"`, so
 * this directive goes only on elements that hold fixed copy (titles, labels,
 * table headers, button texts) and never on containers that can render user
 * data (cards, rows, tables, forms).
 *
 * It applies on its own to every `mat-label` and `th[mat-header-cell]`; add
 * `gdClarityKeepMasked` to one that interpolates data, or `gdClarityUnmask`
 * to any other element with fixed text.
 */
@Directive({
  selector:
    '[gdClarityUnmask], mat-label:not([gdClarityKeepMasked]), th[mat-header-cell]:not([gdClarityKeepMasked])',
  standalone: true,
})
export class ClarityUnmaskDirective {
  @HostBinding('attr.data-clarity-unmask') readonly unmask = 'true';
}
